module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/high-capacity-transport-elite-toolbar.0f8c7a84.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/high-capacity-transport-elite-toolbar.png
// module id = 3714
// module chunks = 11